import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-ps-data',
    templateUrl: './ps-data.component.html',
    styleUrls: ['./ps-data.component.scss'],
    standalone: false
})
export class PsDataComponent implements OnInit {
  @Input() ebitPerShareArray: any[] = [];
  @Input() epsArray: any[] = [];
  @Input() dividentPerShareArray: any[] = [];
  @Input() revenuePerShare: any[] = [];
  @Input() epsFwd: any[] = [];
  @Input() price_to_earning: any[] = [];
  @Input() ticker: string = "";

  // Track if we've received data from children
  barChartInitialized = false;
  tableInitialized = false;
  barChartHasData = false;
  tableHasData = false;

  get showNoDataMessage(): boolean {
    // Only show no data message if both components are initialized and have no data
    return this.barChartInitialized &&
           this.tableInitialized &&
           !this.barChartHasData &&
           !this.tableHasData;
  }

  constructor() { }

  ngOnInit(): void {}

  // Handler for bar chart's data status
  onBarChartDataStatus(hasData: boolean) {
    this.barChartInitialized = true;
    this.barChartHasData = hasData;
  }

  // Handler for table's data status
  onTableDataStatus(hasData: boolean) {
    this.tableInitialized = true;
    this.tableHasData = hasData;
  }
}
